<p-menu #userCard [popup]="true" [model]="userCardItems()"></p-menu>
<div
  class="flex align-items-center justify-content-end xl:justify-content-start px-5 fixed pb-2 pt-3 xl:py-0 xl:relative z-1 surface-ground w-full"
  style="height: 60px"
>
  <a
    pRipple
    pStyleClass="#navigationPanel"
    enterFromClass="hidden"
    enterActiveClass="fadeinleft"
    class="xl:hidden top-0 cursor-pointer text-700 my-3 z-1"
  >
    <i class="pi pi-bars text-4xl"></i>
    <span class="p-ink"></span>
  </a>
  <div class="w-full flex align-items-center justify-content-end">
    <app-theme-toggle></app-theme-toggle>

    @if(showContent()) {
    <p-button
      styleClass="p-button-text ml-2 p-1 border-round"
      (onClick)="userCard.toggle($event)"
    >
      <img
        [src]="'assets/images/user-avatar.svg'"
        class="mr-3 border-circle"
        style="width: 32px; height: 32px"
      />
      <div>
        <div class="text-900 font-semibold">
          {{ authService.user()?.name || authService.identityUser()?.username }}
        </div>
        <span class="text-600 font-semibold text-sm">{{ userRole() }}</span>
      </div>
    </p-button>
    }
  </div>
</div>

<p-blockUI [blocked]="loggingOut"></p-blockUI>
